export default "__VITE_ASSET__BhP7ua75__"